let i = 0;

export default function uniqueFormId() {
  i++;
  return "hues-input-" + i;
}
